// extracted by mini-css-extract-plugin
export default {"textarea":"TextareaFormulario_textarea__jwRAr","campoInput":"TextareaFormulario_campoInput__zSmUU"};